import { h, createContext, Component } from "preact";
import { Router, route } from 'preact-router';
import $ from 'jquery';

import GlobState from 'globstate'
import Globals from "./globals.js";
import * as Apps from "./apps/index.js";
import * as _ from "./components/index.js";

import { TranslateContext } from '@denysvuika/preact-translate';
import { useContext } from 'preact/hooks';

window.app = {
  lang: 'ru',
}

class App extends Component {
  constructor(props) {
    super(props);

    Globals.init();

    let templates = Globals.Templates();

    this.state = {
      time: Date.now(),
      lang: window.app.lang,
      templates: templates
    };

  }

  componentDidMount() {
    setTimeout(() => {
      $("#preloader").addClass("preloader-hide");
      $("#page").css("display", "block");
    }, 300);
  }

  render() {
    const { setLang, t, lang } = useContext(TranslateContext);


    return (<>
      <div id="preloader">
        <div class="spinner-border color-highlight" role="status"></div>
      </div>
      <div class="yourAddElement"></div>
      <div id="page">
        <Router>
          <Apps.home path="/" app={this.state} />
          <Apps.home path="/index.html" app={this.state} />

          <Apps.templates path="/templates" app={this.state} />
          <Apps.test path="/templates/:id" app={this.state} />

          <Apps.marathon path="/marathon" app={this.state} />
          <Apps.marathonTest path="/marathon/:id" app={this.state} />

          <Apps.favs path="/fav" app={this.state} />
          <Apps.favsView path="/fav/:id" app={this.state} />
          <Apps.favsTest path="/fav/test" app={this.state} />

          <Apps.exam path="/test" app={this.state} />

          <Apps.rules path="/rules" app={this.state} />
          <Apps.rule path="/rules/:id" app={this.state} />

          <Apps.err404 type="404" default />
        </Router>

        <div class="modal fade" id="update" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
              <div class="modal-body">
                <div class="d-flex flex-column align-items-center">
                  <span class="mb-3 font20">Вышла новая версия приложения, хотите скачать?</span>
                  <div>
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Отмена</button>
                    <button type="button" class="btn btn-primary">Скачать</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>);
  }
}

export default GlobState.connect(App, Globals);
